import catalogImportPlugin from '@backstage/plugin-catalog-import/alpha';
import { createFrontendModule } from '@backstage/frontend-plugin-api';

const catalogImportPageOverride = catalogImportPlugin
  .getExtension('page:catalog-import')
  .override({
    params: {
      noHeader: true,
    },
  });

export const catalogImportPluginOverride = createFrontendModule({
  pluginId: 'catalog-import',
  extensions: [catalogImportPageOverride],
});
